import React, { Component, useEffect, useRef, useState } from "react";
import {
  Form,
  Button,
  Card,
  Dropdown,
  Row,
  Col,
  Image,
  Modal,
  ListGroup,
  Spinner,
  Alert,
  Badge,
} from "react-bootstrap";
import { Controller, set, useFieldArray, useForm } from "react-hook-form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Select, { createFilter } from "react-select";
import ReactDatePicker from "react-datepicker";
import { LoadModelData } from "./LoadModelData";
import { FixedSizeList as List } from "react-window";

const MyForm = ({ success, setSuccess }) => {
  const [selectedCounty, setSelectedCounty] = useState(""); // Set default selected county
  const [isModelsLoading, setIsModelsLoading] = useState(false);
  const [isModelsDisabled, setIsModelsDisabled] = useState(false);
  const [isModelsClearable, setIsModelsClearable] = useState(false);
  const [isModelsRtl, setIsModelsRtl] = useState(false);
  const [isModelsSearchable, setIsModelsSearchable] = useState(true);
  const [modelError, setModelError] = useState("");
  const [isPurchaseAccountsLoading, setIsPurchaseAccountsLoading] =
    useState(false);
  const [isPurchaseAccountsDisabled, setIsPurchaseAccountsDisabled] =
    useState(false);
  const [isPurchaseAccountsClearable, setIsPurchaseAccountsClearable] =
    useState(false);
  const [isPurchaseAccountsRtl, setIsPurchaseAccountsRtl] = useState(false);
  const [isPurchaseAccountsSearchable, setIsPurchaseAccountsSearchable] =
    useState(true);
  const [purchaseAccountError, setPurchaseAccountError] = useState("");
  const [purchaseDate, setPurchaseDate] = useState(null);
  const [modelsList, setModelsList] = useState([]);
  const [modelSearchString, setModelSearchString] = useState("");
  const [purchaseAccountSearchString, setPurchaseAccountSearchString] =
    useState("");
  const [purchaseAccountCountyFilter, setPurchaseAccountCountyFilter] =
    useState(false);
  const [
    purchaseAccountAddressFilterSwitch,
    setPurchaseAccountAddressFilterSwitch,
  ] = useState(false);
  const [
    purchaseAccountAddressFilterString,
    setPurchaseAccountAddressFilterString,
  ] = useState("");
  const [
    selectedPurchaseAccountFilterCounty,
    setSelectedPurchaseAccountFilterCounty,
  ] = useState("");
  const [purchaseAccountList, setPurchaseAccountList] = useState([]);
  const [filteredPurchaseAccountList, setFilteredPurchaseAccountList] =
    useState([]);
  const [filteredModelsList, setFilteredModelsList] = useState([]);
  const [accountModalOpen, setAccountModalOpen] = useState(false);
  const [modelModalOpen, setModelModalOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertVariant, setAlertVariant] = useState("success");
  const [alertText, setAlertText] = useState("");
  const [formDisabled, setFormDisabled] = useState(false);
  const [counties, setCounties] = useState([]);
  const [questionsMoalOpen, setQuestionsModalOpen] = useState(false);
  const [sclType, setSCLType] = useState(0);
  const [disclaimerChecked, setDisclaimerChecked] = useState(false);
  const [isGasAppliance, setIsGasAppliance] = useState(false);
  const [isNICounty, setIsNICounty] = useState(0);
  const [submitForm, setSubmitForm] = useState(false);
  const formModelRef = useRef(null);
  const formPurchaseAccountRef = useRef(null);
  const [rgiNumber, setRgiNumber] = useState("");
  const [characterCount, setCharacterCount] = useState(0);
  const [characterLimit, setCharacterLimit] = useState(500);
  const [invalidImgFormat, setInvalidImgFormat] = useState(false);
  const [fileExtension, setFileExtension] = useState("");
  const [purchaseAccountChannel, setPurchaseAccountChannel] = useState("");

  useEffect(() => {
    async function fetchModels() {
      try {
        setIsModelsLoading(true);
        setIsModelsDisabled(true);
        if (modelSearchString === "") {
          setModelSearchString("EMPTY_SEARCH_STRING");
        }

        const response = await fetch("/returnModels/" + modelSearchString);
        const json = await response.json();
        const formattedJson = json.map((item) => {
          return {
            value: item.ProductCode,
            label: item.ProductCode,
            description: item.ProductName,
            isGasAppliance: item.IsGas,
          };
        });
        setIsModelsLoading(false);
        setIsModelsDisabled(false);
        setModelsList(formattedJson);
        setFilteredModelsList(formattedJson);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchModels();
  }, [modelSearchString]);

  useEffect(() => {
    async function fetchPurchaseAccounts() {
      try {
        setIsPurchaseAccountsLoading(true);
        setIsPurchaseAccountsDisabled(true);
        if (selectedPurchaseAccountFilterCounty === "") {
          setSelectedPurchaseAccountFilterCounty("EMPTY_SEARCH_STRING");
        } else if (purchaseAccountSearchString === "") {
          setPurchaseAccountSearchString("EMPTY_SEARCH_STRING");
        }
        const response = await fetch(
          "/returnPurchaseAccounts/" +
            purchaseAccountSearchString +
            "/" +
            selectedPurchaseAccountFilterCounty
        );
        const json = await response.json();
        const formattedJson = json.map((item) => {
          return {
            value: item.Code,
            label: item.Code,
            accountName: item.Name,
            address1: item.Addr1,
            county: item.County,
            channel: item.Channel,
          };
        });
        setIsPurchaseAccountsLoading(false);
        setIsPurchaseAccountsDisabled(false);
        setPurchaseAccountList(formattedJson);
        setFilteredPurchaseAccountList(formattedJson);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchPurchaseAccounts();
  }, [
    selectedPurchaseAccountFilterCounty,

    purchaseAccountSearchString,
    purchaseAccountCountyFilter,
  ]);

  useEffect(() => {
    async function fetchCounties() {
      try {
        const response = await fetch("/returnCounties");
        const json = await response.json();
        if (json.length > 0) {
          const formattedJson = json.map((item) => {
            return {
              value: item.County,
              label: item.County,
            };
          });
          setCounties(formattedJson);
          setSelectedCounty(
            formattedJson.find(
              (county) =>
                county.value === "Co. Dublin" || county.value === "Co Dublin"
            ).value
          );
        } else {
          console.error("No Counties found");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchCounties();
  }, []);

  const handleCountyChange = (e, isFilter) => {
    if (isFilter) {
      setSelectedPurchaseAccountFilterCounty(e.target.value);
    } else {
      setSelectedCounty(e.target.value);
      checkIfNICounty(e.target.value);
    }
  };

  const checkIfNICounty = async (county) => {
    try {
      const response = await fetch("/checkIfNICounty/" + county);
      const json = await response.json();
      setIsNICounty(json[0].IsNI);

      if (json[0].IsNI === 1) {
        setSelectedPurchaseAccount("SCLNI"); // If county is in NI, set the default purchase account to SCLNI
      } else {
        setSelectedPurchaseAccount(""); // If county is not in NI, user must select a purchase account
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  let phonePrefix = "0";
  const handleKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault(); // Prevent spaces
    }
  };

  function handleInputChange(e) {
    const inputValue = e.target.value;
    if (!inputValue.startsWith(phonePrefix)) {
      e.target.value = phonePrefix + inputValue.substr(phonePrefix.length);
    }
  }

  const ErrorMessage = ({ text }) => (
    <span className="text-danger">{text}</span>
  );

  const [selectedModel, setSelectedModel] = useState("");
  const [selectedModelDescription, setSelectedModelDescription] = useState("");
  const [selectedPurchaseAccount, setSelectedPurchaseAccount] = useState("");
  const [selectedPurchaseAccountName, setSelectedPurchaseAccountName] =
    useState("");
  const [troubleQuestions, setTroubleQuestions] = useState([]);

  // Fetch trouble questions, each time the model changes
  useEffect(() => {
    async function fetchTroubleQuestions() {
      try {
        const response = await fetch("/returnQuestions/" + selectedModel);
        const json = await response.json();
        setTroubleQuestions(json);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchTroubleQuestions();
  }, [selectedModel]);

  // Form submit and validation
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    setFocus,
    clearErrors,
    control,
    watch,
    setValue,
  } = useForm();
  const onSubmit = async (data, e) => {
    if (purchaseDate == null) {
      errors.purchaseDate = "Purchase Date is required.";
    }

    data.model = selectedModel;
    data.modelDescription = selectedModelDescription;
    data.purchaseAccount = selectedPurchaseAccount;
    data.purchaseName = selectedPurchaseAccountName;
    data.purchaseDate = purchaseDate;
    // let countyObj = counties.find((county) => county.value === selectedCounty);
    // if (countyObj) {
    //   data.isNICounty = countyObj.isNICounty;
    // }

    const formData = new FormData();
    formData.append("file", data.file[0]);
    formData.append("name", data.name);
    formData.append("telNo", data.telNo);
    formData.append("email", data.email);
    formData.append("addr1", data.addr1);
    formData.append("addr2", data.addr2);
    formData.append("addr3", data.addr3);
    formData.append("addr4", data.addr4);
    formData.append("eircode", data.eircode);
    formData.append("county", selectedCounty);
    formData.append("model", data.model);
    formData.append("modelDescription", data.modelDescription);
    formData.append("purchaseAccount", data.purchaseAccount);
    formData.append("purchaseName", data.purchaseName);
    formData.append("purchaseDate", new Date(data.purchaseDate).toISOString());
    formData.append("SCLType", parseInt(data.SCLType));
    formData.append("serialNo", data.serialNo);
    formData.append("warrantyNo", data.warrantyNo);
    formData.append("fileExtension", fileExtension);
    // Here i am adding the RGI number to the issue description if it exists
    let issueDescription = data.issueDescription;
    if (data.modelRGI.length > 0) {
      issueDescription =
        "RGI Number: " + data.modelRGI + " " + issueDescription;
    }
    formData.append("issueDescription", issueDescription);
    formData.append("isNICounty", isNICounty);
    formData.append("PO", data.purchaseOrderNo);

    // Only submit form if submitForm is true
    if (submitForm) {
      const response = await fetch("/submitCall", {
        method: "POST",
        headers: {
          // "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: formData,
        files: data.file,
      })
        .then((response) => {
          if (response.status === 200) {
            // // move to top of page and show success alert
            window.scrollTo(0, 0);
            // setAlertVariant("success");
            // setAlertText("Success - Service Call Logged");
            // setAlertOpen(true);
            // resetForm();
            setSuccess(true);
          } else {
            alert("Error submitting call.");
            window.scrollTo(0, 0);
            setAlertVariant("danger");
            setAlertText("Error submitting call.");
            setAlertOpen(true);
          }
        })
        .catch((error) => {
          console.error("Error submitting call:", error);
        });
      setModelError("");
    }

    // alert(JSON.stringify(data));
  };

  const handleFilter = (e) => {
    setPurchaseAccountSearchString(e);
    let filteredList = purchaseAccountList.filter((item) => {
      return item.label.toLowerCase().includes(e.toLowerCase());
    });
    setFilteredPurchaseAccountList(filteredList);
  };

  const handleModelFilter = (e) => {
    setModelSearchString(e);
    let filteredList = modelsList.filter((item) => {
      return item.label.toLowerCase().includes(e.toLowerCase());
    });
    setFilteredModelsList(filteredList);
  };

  const CustomAlert = ({ variant, text }) => {
    return (
      <Alert
        variant={variant}
        dismissible
        show={alertOpen}
        onClose={() => setAlertOpen(false)}
      >
        {text}
      </Alert>
    );
  };

  const resetForm = () => {
    setSubmitForm(false);
    setSelectedModel("");
    setSelectedModelDescription("");
    setFilteredModelsList([]);
    setSelectedPurchaseAccount("");
    setSelectedPurchaseAccountName("");
    setPurchaseDate(new Date());
    setModelSearchString("");
    setPurchaseAccountSearchString("");
    setPurchaseAccountCountyFilter(false);
    setPurchaseAccountAddressFilterSwitch(false);
    setPurchaseAccountAddressFilterString("");
    setSelectedPurchaseAccountFilterCounty("");
    setSelectedCounty(
      counties.find(
        (county) =>
          county.value === "Co. Dublin" || county.value === "Co Dublin"
      ).value
    );
    setSCLType(0);
    setRgiNumber("");
    setIsGasAppliance(false);
    setIsNICounty(0);
    setCharacterCount(0);
    setCharacterLimit(500);
    clearErrors();
    reset();
  };

  // Helper function to remove "Co" prefix
  const removeCoPrefix = (label) => label.replace(/^Co\.?/, "");

  const handleFile = (e) => {
    const file = e.target.files[0];
    // remove file error
    //clearErrors("file");

    // Get the file extension
    const fileExtension = file.name.split(".").pop().toLowerCase();

    setFileExtension(fileExtension);
    // Check if the file extension indicates a HEIC file
    if (fileExtension === "heic" || fileExtension === "heif") {
      setInvalidImgFormat(true);

      alert("Please upload a JPEG or PNG image. HEIC format is not supported.");
      return; // Stop further processing
    }
  };

  const logAnotherJob = () => {
    setSuccess(false);
    resetForm();
    // reload the page
    window.location.reload();
  };

  const handleSCLSelect = (e) => {
    setSCLType(parseInt(e.target.value));
  };

  useEffect(() => {
    // This will run after every render when sclType changes
    console.log(sclType, selectedModel, purchaseDate);
  }, [sclType, selectedModel, purchaseDate]);

  useEffect(() => {
    if (submitForm) {
      handleSubmit(onSubmit)();
      setQuestionsModalOpen(false);
      setDisclaimerChecked(false);
    }
  }, [submitForm, selectedPurchaseAccount, selectedModel, purchaseDate]);

  useEffect(() => {
    console.log("errors ", errors);
  }, [errors]);

  if (success) {
    return (
      <div>
        <h2>Success!</h2>
        <p>Your job has been submitted successfully.</p>
        <Button onClick={logAnotherJob}>Log another job</Button>
      </div>
    );
  }

  return (
    <>
      {alertOpen && <CustomAlert variant={alertVariant} text={alertText} />}

      <Card className="p-3">
        <div className="py-4 d-flex align-items-center justify-content-center">
          <Image src="/kal-logo.png" height={35} width={35} />
          <h1 className=" ms-2 mb-0">Log Service Call</h1>
        </div>

        {/* <Card.Header>Customer Details</Card.Header> */}
        <Card.Body>
          {/* <Card.Title>Special title treatment</Card.Title> */}
          <Form encType="multipart/form-data" onSubmit={handleSubmit(onSubmit)}>
            {/* Customer details section */}
            <legend className="mb-3 d-flex align-items-center">
              <span className="number me-2">1</span> Customer Details
            </legend>
            <Row>
              <Col sm={12} md={6}>
                <FloatingLabel
                  controlId="formName"
                  label="Name"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Name"
                    {...register("name", {
                      required: "Name is required.",
                      maxLength: {
                        value: 30,
                        message: "Name must be less than 30 characters.",
                      },
                    })}
                    isInvalid={errors.name}
                  />
                  {errors.name && <ErrorMessage text={errors.name.message} />}
                </FloatingLabel>
              </Col>
              <Col md={6}>
                <FloatingLabel
                  controlId="formPhone"
                  label="Phone Number"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    //defaultValue={phonePrefix} // Set the default value with prefix
                    {...register("telNo", {
                      required: "Phone number is required.",
                      minLength: {
                        value: 10,
                        message: "Phone number must be at least 10 digits.",
                      },
                      pattern: {
                        value: /^[0-9]*$/,
                        message: "Phone number must be numeric.",
                      },
                      //must start with a 0
                      validate: (value) => {
                        if (!value.startsWith("0")) {
                          return "Phone number must start with 0.";
                        }
                      },
                    })}
                    // onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    isInvalid={errors.telNo}
                    placeholder="Phone Number"
                  />
                  {errors.telNo && <ErrorMessage text={errors.telNo.message} />}
                </FloatingLabel>
              </Col>

              <Col md={6}>
                <FloatingLabel
                  controlId="formEmail"
                  label="Email"
                  className="mb-3"
                >
                  <Form.Control
                    type="email"
                    {...register("email", {
                      required: "Email is required.",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Invalid email address.",
                      },
                      maxLength: {
                        value: 50,
                        message: "Email must be less than 50 characters.",
                      },
                    })}
                    onKeyDown={handleKeyDown}
                    isInvalid={errors.email}
                    placeholder="Email"
                  />
                  {errors.email && <ErrorMessage text={errors.email.message} />}
                </FloatingLabel>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Form.Group controlId="formAddress1">
                  <Form.Label className="fw-medium">Address</Form.Label>
                  <FloatingLabel
                    controlId="formAddr1"
                    label="Line 1"
                    className="mb-2"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Address line 1.."
                      {...register("addr1", {
                        required: "Address line 1 is required.",
                        maxLength: {
                          value: 50,
                          message:
                            "Address line 1 must be less than 50 characters.",
                        },
                      })}
                      isInvalid={errors.addr1}
                    />
                    {errors.addr1 && (
                      <ErrorMessage text={errors.addr1.message} />
                    )}
                  </FloatingLabel>
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group controlId="formAddress2">
                  <FloatingLabel
                    controlId="formAddr2"
                    label="Line 2"
                    className="mb-2"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Address line 2.."
                      {...register("addr2", {
                        required: "Address line 2 is required.",
                        maxLength: {
                          value: 50,
                          message:
                            "Address line 2 must be less than 50 characters.",
                        },
                      })}
                      isInvalid={errors.addr2}
                    />
                    {errors.addr2 && (
                      <ErrorMessage text={errors.addr2.message} />
                    )}
                  </FloatingLabel>
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group controlId="formAddress3">
                  <FloatingLabel
                    controlId="formAddr3"
                    label="Line 3"
                    className="mb-2"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Address line 3.."
                      {...register("addr3")}
                    />
                  </FloatingLabel>
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group controlId="formAddress4">
                  <FloatingLabel
                    controlId="formAddr4"
                    label="Line 4"
                    className="mb-2"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Address line 4.."
                      {...register("addr4")}
                    />
                  </FloatingLabel>
                </Form.Group>
              </Col>
              <Col md={{ order: "last" }}>
                <FloatingLabel
                  controlId="Eircode"
                  label="Postal Code"
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    {...register("eircode", {
                      required: "Postal Code is required.",
                    })}
                    isInvalid={errors.eircode}
                    placeholder="Eircode"
                  />
                  {errors.eircode && (
                    <ErrorMessage text={errors.eircode.message} />
                  )}
                </FloatingLabel>
              </Col>
              <Col md={6}>
                <FloatingLabel
                  controlId="floatingSelect"
                  label="Select a County"
                >
                  <Form.Control
                    as="select"
                    value={selectedCounty}
                    {...register("county")}
                    onChange={handleCountyChange}
                  >
                    {counties
                      .sort((a, b) =>
                        removeCoPrefix(a.label) > removeCoPrefix(b.label)
                          ? 1
                          : -1
                      )
                      .map((county, index) => (
                        <option key={index} value={county.value}>
                          {county.label}
                        </option>
                      ))}
                  </Form.Control>
                </FloatingLabel>
              </Col>
            </Row>

            {/* Product details section */}
            <legend className="mt-5 mb-3 d-flex align-items-center">
              <span className="number me-2">2</span> Product Details
            </legend>

            <Row>
              <Col md={12}>
                <Form.Group controlId="formModel" ref={formModelRef}>
                  <Form.Label className="fw-medium">Choose Model</Form.Label>
                  <Form.Group>
                    <Button
                      variant="secondary"
                      onClick={() => setModelModalOpen(true)}
                      className={errors.model ? "" : "mb-3"}
                    >
                      {selectedModelDescription !== "" ? "Change" : "Select"}{" "}
                      Model
                    </Button>
                  </Form.Group>

                  <Modal
                    centered
                    show={modelModalOpen}
                    onHide={() => {
                      setModelModalOpen(false);
                      setModelSearchString("");
                    }}
                  >
                    <Modal.Header className="bg-primary text-white" closeButton>
                      <Modal.Title>Choose Model</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form.Label>Search for a model..</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Search here..."
                        onChange={(e) => {
                          handleModelFilter(e.target.value);
                        }}
                        className="mt-2"
                      />
                      <p className="mt-4 fw-medium text-primary">
                        Choose from the list below:
                      </p>

                      <ListGroup as="ol">
                        <input
                          style={{ display: "none" }}
                          {...register("model", {
                            required: "Model is required.",
                          })}
                        />
                        {filteredModelsList ? (
                          filteredModelsList.map((item, index) => {
                            return (
                              <ListGroup.Item
                                as="li"
                                key={index}
                                href={`#link${index}`}
                                action
                                onClick={() => {
                                  setValue("model", item.label, {
                                    shouldValidate: true,
                                  });
                                  setSelectedModel(item.label);
                                  setSelectedModelDescription(item.description);
                                  setIsGasAppliance(item.isGasAppliance);
                                  setModelError("");
                                  setModelModalOpen(false);
                                  clearErrors("model");
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.cursor = "pointer";
                                }}
                              >
                                <div className="ms-2 my-2 me-auto">
                                  <div className="fw-bold">{item.label}</div>
                                  <p className="m-0"> {item.description}</p>
                                </div>
                              </ListGroup.Item>
                            );
                          })
                        ) : (
                          // .slice(0, 100)
                          <Spinner animation="border" variant="primary" />
                        )}
                      </ListGroup>
                    </Modal.Body>
                    <Modal.Footer></Modal.Footer>
                  </Modal>

                  {errors.model && selectedModel === "" ? (
                    <ErrorMessage text={errors.model.message} />
                  ) : (
                    <></>
                  )}
                  {/* <Select
                    placeholder="Search for model.."
                    className="basic-single mb-3"
                    classNamePrefix="select"
                    // defaultValue={null}
                    isDisabled={isModelsDisabled}
                    isLoading={!modelsList.length}
                    isClearable={isModelsClearable}
                    isRtl={isModelsRtl}
                    isSearchable={isModelsSearchable}
                    name="formModel"
                    options={modelsList}
                    menuPlacement="auto"
                    // onInputChange={(e) => {
                    //   setModelSearchString(e);
                    // }}
                    onChange={(e) => {
                      setSelectedModel(e.label);
                      setSelectedModelDescription(e.description);
                      setModelError("");
                    }}
                    styles={{
                      menuPortal: (provided) => ({
                        ...provided,
                        zIndex: 9999,
                      }),
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 9999,
                        top: "auto",
                        bottom: "100%",
                      }),
                    }}
                  /> */}
                  {modelError && <ErrorMessage text={modelError} />}
                </Form.Group>
              </Col>
              <Col sm={12} md={4}>
                <Form.Group controlId="formProductCode">
                  <FloatingLabel
                    hidden={selectedModel === ""}
                    controlId="formProductCode"
                    label="Product Code"
                    className="mb-3 z-0"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Product Code"
                      // disabled
                      readOnly
                      value={selectedModel}
                    />
                  </FloatingLabel>
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group controlId="formModelDescription">
                  <FloatingLabel
                    hidden={selectedModelDescription === ""} // Hide the label if there is no description
                    controlId="formModelDescription"
                    label="Description"
                    className="mb-3 z-0"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Description"
                      {...register("modelDescription")}
                      // disabled
                      readOnly
                      value={selectedModelDescription}
                    />
                  </FloatingLabel>
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group controlId="formModelRGI">
                  <FloatingLabel
                    hidden={!isGasAppliance}
                    controlId="formModelRGI"
                    label="RGI Certificate Number"
                    className="mb-3 z-0"
                  >
                    <Form.Control
                      isInvalid={errors.modelRGI || rgiNumber.length < 3}
                      type="text"
                      value={rgiNumber}
                      required={isGasAppliance}
                      placeholder="RGI Certificate Number"
                      {...register("modelRGI", {
                        required: isGasAppliance
                          ? "RGI is required for gas appliances"
                          : false,
                      })}
                      aria-describedby="rgiRequiredText"
                      // when the user enters the input
                      onClick={(e) => {
                        if (rgiNumber === "") {
                          setRgiNumber("EX");
                        }
                        //setRgiNumber("EX");
                      }}
                      onChange={(e) => {
                        const inputValue = e.target.value;

                        // Check if the input value starts with "EX"
                        if (inputValue.startsWith("EX")) {
                          // If yes, update the state
                          setRgiNumber(inputValue);
                          clearErrors("modelRGI");
                        } else if (inputValue === "E" && rgiNumber === "EX") {
                          // Special case for backspace after "EX"
                          setRgiNumber("EX");
                          clearErrors("modelRGI");
                        } else {
                          // If not, reset the value to include the "EX" prefix
                          setRgiNumber("EX" + inputValue);
                          clearErrors("modelRGI");
                        }
                      }}
                    />
                    <Form.Text
                      id="rgiRequiredText"
                      className="fw-medium text-danger"
                    >
                      This is a gas appliance. A RGI certificate is mandatory
                      for gas appliances. We cannot accept service requests for
                      appliances that do not have a RGI certificate. Please
                      enter the RGI certificate number.
                    </Form.Text>
                  </FloatingLabel>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Control
                  as="select"
                  className={`z-0 ${errors.SCLType ? "" : "mb-3"}`}
                  defaultValue={sclType}
                  {...register("SCLType", {
                    required: "Issue Type is required.",

                    validate: (value) => {
                      if (value === "0" || value === 0) {
                        return "Please select an Issue Type.";
                      }
                    },
                  })}
                  onChange={(e) => {
                    clearErrors("SCLType"); // Clear errors for the 'SCLType' field
                    handleSCLSelect(e);
                    setSCLType(parseInt(e.target.value));
                  }}
                  // onChange={(e) => {
                  //   setSCLType(parseInt(e.target.value));
                  //   errors.SCLType = null;
                  // }}
                  isInvalid={errors.SCLType}
                >
                  {/* default value - not selected */}
                  <option value="0" selected disabled>
                    Select Issue Type
                  </option>
                  <option value="1">1 - Warranty</option>
                  <option value="2">2 - Non Warranty</option>
                </Form.Control>
                {errors.SCLType && (
                  <ErrorMessage text={errors.SCLType.message} />
                )}
              </Col>

              <Col md={12}>
                <Form.Group
                  controlId="formPurchaseDate"
                  className="mb-3 d-flex flex-column"
                >
                  <Form.Label className="fw-medium">
                    Select Purchase Date
                  </Form.Label>
                  <div style={{ zIndex: 100, fontSize: 0 }}>
                    <Controller
                      control={control}
                      name="purchaseDate"
                      rules={{ required: "Purchase Date is required." }}
                      render={({ field }) => (
                        <ReactDatePicker
                          placeholderText=""
                          dateFormat={"dd/MM/yyyy"}
                          selected={field.value}
                          onChange={(date) => {
                            const utcDate = new Date(
                              Date.UTC(
                                date.getFullYear(),
                                date.getMonth(),
                                date.getDate()
                              )
                            );
                            field.onChange(utcDate);
                            setPurchaseDate(utcDate);
                            clearErrors("purchaseDate");
                          }}
                          maxDate={new Date()}
                          className={
                            "form-control " +
                            (errors.purchaseDate && "border-danger")
                          }
                          zIndex={9999}
                        />
                      )}
                    />
                  </div>

                  {errors.purchaseDate ? (
                    <ErrorMessage text="Purchase Date is required." />
                  ) : (
                    <></>
                  )}
                </Form.Group>
              </Col>

              <Col md={12} hidden={isNICounty}>
                <Form.Group
                  controlId="formPurchaseAccount"
                  ref={formPurchaseAccountRef}
                >
                  <Form.Label className="fw-medium">
                    Choose Purchase Account
                  </Form.Label>
                  <Form.Group>
                    <Button
                      variant="secondary"
                      onClick={() => setAccountModalOpen(true)}
                      className={errors.purchaseAccount ? "" : "mb-3"}
                    >
                      {selectedPurchaseAccount !== "" ? "Change" : "Select"}{" "}
                      Purchase Account
                    </Button>
                  </Form.Group>

                  {/* <Select
                    placeholder="Search for purchase account.."
                    className="basic-single mb-3"
                    classNamePrefix="select"
                    // defaultValue={null}
                    isDisabled={isPurchaseAccountsDisabled}
                    isLoading={isPurchaseAccountsLoading}
                    isClearable={isPurchaseAccountsClearable}
                    isRtl={isPurchaseAccountsRtl}
                    isSearchable={isPurchaseAccountsSearchable}
                    name="formPurchaseAccount"
                    options={purchaseAccountList}
                    menuPlacement="auto"
                    onChange={(e) => {
                      setSelectedPurchaseAccount(e.label);
                      setSelectedPurchaseAccountName(e.accountName);
                      setPurchaseAccountError("");
                    }}
                    styles={{
                      menuPortal: (provided) => ({
                        ...provided,
                        zIndex: 9999,
                      }),
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 9999,
                        top: "auto",
                        bottom: "100%",
                      }),
                    }}
                    filterOption={createFilter({ ignoreAccents: false })} // imporve performance
                  /> */}
                  <Modal
                    centered
                    show={accountModalOpen}
                    onHide={() => {
                      setAccountModalOpen(false);
                      setPurchaseAccountCountyFilter(false);
                      setPurchaseAccountAddressFilterSwitch(false);
                    }}
                  >
                    <Modal.Header className="bg-primary text-white" closeButton>
                      <Modal.Title>Choose Purchase Account</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form.Label>Search for purchase account..</Form.Label>
                      {/* <Form.Check // prettier-ignore
                        type="switch"
                        id="accountCountySwitch"
                        label="Filter by County"
                        onChange={(e) => {
                          setSelectedPurchaseAccountFilterCounty("");
                          setPurchaseAccountCountyFilter(
                            !purchaseAccountCountyFilter
                          );
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.cursor = "pointer";
                        }}
                      /> */}
                      {/* <Form.Check // prettier-ignore
                        type="switch"
                        id="accountAddressSwitch"
                        label="Filter by Address"
                        onChange={(e) => {
                          setPurchaseAccountAddressFilterString("");
                          setPurchaseAccountAddressFilterSwitch(
                            !purchaseAccountAddressFilterSwitch
                          );
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.cursor = "pointer";
                        }}
                      /> */}
                      <Row>
                        <Col sm={6}>
                          {/* <FloatingLabel
                            //hidden={!purchaseAccountCountyFilter}
                            controlId="floatingSelect"
                            label="Filter by County"
                            className="mt-3 mb-2"
                          > */}
                          <Form.Control
                            as="select"
                            // defaultValue={selectedCounty}
                            value={selectedPurchaseAccountFilterCounty}
                            onChange={(e) => handleCountyChange(e, true)}
                          >
                            <option value="">Select County</option>
                            {counties
                              .sort((a, b) =>
                                removeCoPrefix(a.label) >
                                removeCoPrefix(b.label)
                                  ? 1
                                  : -1
                              )
                              .map((county, index) => (
                                <option key={index} value={county.value}>
                                  {county.label}
                                </option>
                              ))}
                          </Form.Control>

                          {/* </FloatingLabel> */}
                        </Col>

                        {/* <Col sm={12}>
                          <Form.Group controlId="purchaseAccountAddressFilter">
                            <FloatingLabel
                              hidden={!purchaseAccountAddressFilterSwitch}
                              controlId="purchaseAccountAddressFilter"
                              label="Purchase Account Address..."
                              className="mb-2"
                            >
                              <Form.Control
                                type="text"
                                placeholder="Purchase Account Address"
                                onChange={(e) => {
                                  setPurchaseAccountAddressFilterString(
                                    e.target.value
                                  );
                                }}
                              />
                            </FloatingLabel>
                          </Form.Group>
                        </Col> */}
                      </Row>
                      <Form.Control
                        type="text"
                        placeholder="Search here..."
                        onChange={(e) => {
                          // setPurchaseAccountAddressFilterString(e.target.value);
                          handleFilter(e.target.value);
                        }}
                        className="mt-2"
                      />

                      <p className="mt-4 fw-medium text-primary">
                        Choose from the list below:
                      </p>

                      <ListGroup as="ol">
                        <input
                          style={{ display: "none" }}
                          // {...register("purchaseAccount", {
                          //   required: "Purchase Account is required.",
                          // })}
                          // required only if isNICounty is false

                          {...register("purchaseAccount", {
                            required: isNICounty
                              ? false
                              : "Purchase Account is required.",
                          })}
                        />
                        {filteredPurchaseAccountList ? (
                          filteredPurchaseAccountList.map((item, index) => {
                            return (
                              <ListGroup.Item
                                as="li"
                                className="d-flex justify-content-between align-items-start"
                                key={index}
                                href={`#link${index}`}
                                action
                                onClick={() => {
                                  setValue("purchaseAccount", item.label, {
                                    shouldValidate: true,
                                  });
                                  setSelectedPurchaseAccount(item.label);
                                  setSelectedPurchaseAccountName(
                                    item.accountName
                                  );
                                  setPurchaseAccountChannel(item.channel);
                                  setPurchaseAccountError("");
                                  setAccountModalOpen(false);
                                  setPurchaseAccountCountyFilter(false);
                                  setPurchaseAccountAddressFilterSwitch(false);
                                  clearErrors("purchaseAccount");
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.cursor = "pointer";
                                }}
                              >
                                <div className="ms-2 me-auto">
                                  <div className="fw-bold">{item.label}</div>
                                  <p className="m-0"> {item.accountName}</p>
                                  <p className="m-0">{item.address1}</p>
                                </div>
                                <Badge bg="secondary" pill>
                                  {item.county}
                                </Badge>
                              </ListGroup.Item>
                            );
                          })
                        ) : (
                          <Spinner animation="border" variant="primary" />
                        )}
                      </ListGroup>
                    </Modal.Body>
                    <Modal.Footer></Modal.Footer>
                  </Modal>
                  {errors.purchaseAccount && selectedPurchaseAccount === "" ? (
                    <ErrorMessage text={errors.purchaseAccount.message} />
                  ) : (
                    <></>
                  )}
                </Form.Group>
              </Col>
              {/* <Col sm={12} md={4}>
                <Form.Group controlId="formPurchaseAccountCode">
                  <FloatingLabel
                    hidden={selectedPurchaseAccount === ""}
                    controlId="formPurchaseAccountCode"
                    label="Account Code"
                    className="mb-2 z-0 mt-2"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Account Code"
                      disabled
                      readOnly
                      value={selectedPurchaseAccount}
                    />
                  </FloatingLabel>
                </Form.Group>
              </Col> */}
              <Col md={12}>
                <Form.Group controlId="formPurchaseName">
                  <FloatingLabel
                    hidden={selectedPurchaseAccountName === ""}
                    controlId="formPurchaseName"
                    label="Purchase Name"
                    className="mb-3 z-0"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Purchase Name"
                      {...register("purchaseName")}
                      disabled
                      readOnly
                      value={selectedPurchaseAccountName}
                    />
                  </FloatingLabel>
                </Form.Group>
              </Col>

              <Col className="mb-2 mb-md-0" md={6}>
                <Form.Group controlId="formSerialNo">
                  <FloatingLabel controlId="formSerialNo" label="Serial No.">
                    <Form.Control
                      type="text"
                      placeholder="Serial No."
                      isInvalid={errors.serialNo}
                      {...register("serialNo", {
                        maxLength: {
                          value: 30,
                          message:
                            "Serial number must be less than 30 characters.",
                        },
                      })}
                    />
                  </FloatingLabel>
                  <ErrorMessage text={errors.serialNo?.message} />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="formWarrantyRegNo">
                  <FloatingLabel
                    controlId="formWarrantyRegNo"
                    label="Warranty Reg No."
                  >
                    <Form.Control
                      type="text"
                      placeholder="Warranty Reg No."
                      isInvalid={errors.warrantyNo}
                      {...register("warrantyNo", {
                        maxLength: {
                          value: 30,
                          message:
                            "Warranty number must be less than 30 characters.",
                        },
                      })}
                    />
                  </FloatingLabel>
                  <ErrorMessage text={errors.warrantyNo?.message} />
                </Form.Group>
              </Col>
            </Row>

            {/* Issue Description section */}
            <legend className="mt-5 mb-3 d-flex align-items-center">
              <span className="number me-2">3</span> Issue Description – Cause,
              Symptoms & Remedies
            </legend>
            <Form.Control
              as="textarea"
              placeholder="To help us resolve your issue quickly, please enter a full description of the issue including suspected cause, symptoms and any remedial actions that you have taken already – More is better!!"
              style={{ height: "100px" }}
              className="textarea-placeholder"
              {...register("issueDescription", {
                required: "Issue description is required.",
                maxLength: {
                  value: characterLimit,
                  message: `Description must be ${characterLimit} characters or less.`,
                },
              })}
              isInvalid={errors.issueDescription}
              onChange={(e) => {
                const inputText = e.target.value;
                setCharacterCount(inputText.length);
                // Update validation based on character count
                if (inputText.length > characterLimit) {
                  errors.issueDescription = true;
                } else {
                  clearErrors("issueDescription");
                }
              }}
              onFocus={(e) => {
                // clear placeholder text
                e.target.placeholder = "";
              }}
            />
            <Form.Text
              className={characterCount > characterLimit ? "text-danger" : ""}
            >
              {characterCount} / {characterLimit}
            </Form.Text>
            {errors.issueDescription && (
              <ErrorMessage text={errors.issueDescription.message} />
            )}

            {/* Proof of Purchase section */}
            <legend className="mt-5 mb-3 d-flex align-items-center">
              <span className="number me-2">4</span> Proof of Purchase
            </legend>
            <Form.Group
              controlId="formFile"
              className="mb-3"
              hidden={purchaseAccountChannel === "Kitchen and Contract"}
            >
              <Form.Label className="fw-medium">
                Upload proof of purchase image
              </Form.Label>
              <input
                type="file"
                name="file"
                required
                className="form-control"
                {...register("file", {
                  // Required only if purchaseAccountChannel is not Kitchen and Contract
                  required:
                    purchaseAccountChannel !== "Kitchen and Contract"
                      ? "Proof of purchase is required."
                      : false,

                  validate: {
                    fileFormat: (value) => {
                      const acceptedFormats = [
                        "image/jpeg",
                        "image/png",
                        "image/bmp",
                        "application/pdf",
                        "application/msword",
                        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                        "application/vnd.ms-excel",
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        "text/plain",
                        "text/csv",
                        "text/tab-separated-values",
                        "application/vnd.ms-excel",
                        "text/html",
                        "image/gif",
                        "video/quicktime",
                        "video/mp4",
                      ];
                      //return acceptedFormats.includes(value[0]?.type);
                      if (
                        purchaseAccountChannel !== "Kitchen and Contract" &&
                        !acceptedFormats.includes(value[0]?.type)
                      ) {
                        return "Invalid file format. Please upload a valid file.";
                      }
                      return true;
                    },
                  },
                })}
                onChange={handleFile}
                //accept only certain file types
                // accept="image/png, image/jpeg, image/bmp, image/heic"
                accept="image/png, image/jpeg, image/bmp,.pdf,.doc,.docs,.xlsx,.xls,.txt,.dat,.html,.gif,.mov,.mp4"
              />
              <Form.Text>
                No Proof of purchase? Please contact your retailer to log a call
                on your behalf
              </Form.Text>

              {errors.file && <ErrorMessage text={errors.file.message} />}
            </Form.Group>

            <Modal
              centered
              show={questionsMoalOpen}
              onHide={() => {
                setQuestionsModalOpen(false);
                setDisclaimerChecked(false);
                // setModelSearchString("");
              }}
            >
              <Modal.Header className="bg-primary text-white" closeButton>
                <Modal.Title>Questions</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <ListGroup as="ol">
                  {troubleQuestions ? (
                    troubleQuestions.map((question, index) => {
                      return (
                        <ListGroup.Item
                          as="li"
                          key={index}
                          // href={`#link${index}`}
                          action
                          // onClick={() => {
                          //   setSelectedModel(item.label);
                          //   setSelectedModelDescription(
                          //     item.description
                          //   );
                          //   setModelError("");
                          //   setModelModalOpen(false);
                          // }}
                          // onMouseEnter={(e) => {
                          //   e.target.style.cursor = "pointer";
                          // }}
                        >
                          <p className="fw-medium p-0">
                            {index + 1}. {question.Question}
                          </p>
                        </ListGroup.Item>
                      );
                    })
                  ) : (
                    <Spinner animation="border" variant="primary" />
                  )}
                </ListGroup>
                <p className="mt-3">
                  You have indicated that this is a warranty call. Have you
                  checked all the items above. Please ensure you have checked
                  all these items before logging the call
                </p>
                <p className="text-danger fw-bold text-decoration-underline">
                  If the issue is found to be a user issue, you will be charged
                  for engineer call out time and parts costs
                </p>

                {/* <Form.Check // prettier-ignore
                  type="checkbox"
                  label={"I agree to the above"}
                  onChange={() => setDisclaimerChecked(!disclaimerChecked)}
                  className="fw-bold"
                /> */}
                <div class="custom-control custom-checkbox checkbox-xl">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="checkbox-3"
                    onChange={() => setDisclaimerChecked(!disclaimerChecked)}
                  />
                  <label
                    class="custom-control-label fw-bold ps-3 mb-0"
                    for="checkbox-3"
                  >
                    I agree to the above
                  </label>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => {
                    setQuestionsModalOpen(false);
                    setDisclaimerChecked(false);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  // type="submit"
                  variant="success"
                  disabled={!disclaimerChecked}
                  onClick={() => {
                    setSubmitForm(true); // This will trigger form submission and call onSubmit if validation passes
                    //handleSubmit(onSubmit)(); // This will trigger form submission and call onSubmit if validation passes
                    //setQuestionsModalOpen(false); // Close the modal regardless of form submission status
                    //setDisclaimerChecked(false);
                  }}
                >
                  Confirm
                </Button>
              </Modal.Footer>
            </Modal>

            <Row hidden={purchaseAccountChannel !== "Kitchen and Contract"}>
              <Col md={12}>
                <Form.Group controlId="formPO">
                  <FloatingLabel controlId="formPO" label="Purchase Order No.">
                    <Form.Control
                      type="text"
                      placeholder="Purchase Order No."
                      isInvalid={errors.purchaseOrderNo}
                      {...register("purchaseOrderNo", {
                        maxLength: {
                          value: 30,
                          message:
                            "Purchase Order number must be less than 30 characters.",
                        },
                        // required only if purchaseAccountChannel is Kitchen and Contract
                        required:
                          purchaseAccountChannel === "Kitchen and Contract"
                            ? "Purchase Order Number is required."
                            : false,
                      })}
                    />
                  </FloatingLabel>
                  <Form.Text>
                    No Purchase Order? Please contact your retailer to log a
                    call on your behalf
                  </Form.Text>
                  <ErrorMessage text={errors.purchaseOrderNo?.message} />
                </Form.Group>
              </Col>
            </Row>

            <div className="d-grid mt-5">
              <Button
                //type="submit"
                variant="primary"
                size="lg"
                disabled={formDisabled}
                onClick={() => {
                  handleSubmit(onSubmit)();

                  if (
                    parseInt(sclType) === 1 &&
                    Object.keys(errors).length === 0
                  ) {
                    if (troubleQuestions.length > 0) {
                      setQuestionsModalOpen(true);
                    } else {
                      setSubmitForm(true);
                    }
                  } else if (
                    parseInt(sclType) === 2 &&
                    Object.keys(errors).length === 0
                  ) {
                    setSubmitForm(true);
                    // handleSubmit(onSubmit)();
                  }
                }}
              >
                Submit
              </Button>
            </div>
          </Form>
        </Card.Body>
        {/* <form method="POST" action="/submitCall" encType="multipart/form-data">
          <input type="file" name="file" onChange={handleFile} />
          <input type="submit" value="Submit" />
        </form> */}
      </Card>
    </>
  );
};

export default MyForm;
